// bao migrate skip
import "./../../bindings/bao-tabs";
import "./../../factories/translate-dialog";
import "./../../bindings/bao-searcher";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import BaseViewModel2 from "./../../factories/base-view-model2";
import baoRouter from "./../../services/bao-router";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
import TranslateDialogViewModel from "./../../factories/translate-dialog";
class CategoryViewModel extends BaseViewModel2 {
    InitUrl() {
        return ""; //not needed
    }
    CategoryStructureId: KnockoutObservable<string>;
    //CategoryTypeId: KnockoutObservable<any> = ko.observable();
    //CategoryTypeName: KnockoutObservable<string> = ko.observable("");
    Categorytypes: KnockoutObservableArray<any> = ko.observableArray([]);
    TabController = new TabController(false);
    ShiftbookCategoryTab;
    TextFocus = ko.observable(true);
    //OpenData = ko.observable(null);
    SaveTime = ko.observable(null);
    CategoryColors = ko.observableArray([]);
    Category: KnockoutObservable<{
        CategoryId: KnockoutObservable<any>;
        CategoryName: KnockoutComputed<any>;
        CategoryName1: KnockoutObservable<any>;
        CategoryName2: KnockoutObservable<any>;
        CategoryName3: KnockoutObservable<any>;
        CategoryName4: KnockoutObservable<any>;
        CategoryName5: KnockoutObservable<any>;
        CategoryTypeId: KnockoutObservable<any>;
        CategoryTypeName: KnockoutObservable<any>;
    }> = ko.observable({
        CategoryId: ko.observable(),
        CategoryTypeId: ko.observable(),
        CategoryTypeName: ko.observable(),
        CategoryName: ko.pureComputed({
            read: () => {
                switch (Bao.Session.Language.LanguageIndex()) {
                    case 1:
                        return this.Category().CategoryName1();
                    case 2:
                        return this.Category().CategoryName2();
                    case 3:
                        return this.Category().CategoryName3();
                    case 4:
                        return this.Category().CategoryName4();
                    case 5:
                        return this.Category().CategoryName5();
                }
            },
            write: (value) => {
                switch (Bao.Session.Language.LanguageIndex()) {
                    case 1:
                        this.Category().CategoryName1(value);
                        break;
                    case 2:
                        this.Category().CategoryName2(value);
                        break;
                    case 3:
                        this.Category().CategoryName3(value);
                        break;
                    case 4:
                        this.Category().CategoryName4(value);
                        break;
                    case 5:
                        this.Category().CategoryName5(value);
                        break;
                }
            }
        }),
        CategoryName1: ko.observable(),
        CategoryName2: ko.observable(),
        CategoryName3: ko.observable(),
        CategoryName4: ko.observable(),
        CategoryName5: ko.observable(),
    });
    PermissionDelete = ko.observable("CategoryDelete");
    PermissionQRCode = ko.observable(null);
    PermissionRefresh = ko.observable("CategoryRefresh");
    PermissionSave = ko.observable("CategorySave");
    PermissionSearch = ko.observable("CategoryRefresh");
    RefreshUrl = ko.observable("MasterData/Category/GetCategory");
    SaveUrl = ko.observable("MasterData/Category/Save");
    DeleteUrl = ko.observable("MasterData/Category/Delete");
    IsInUseUrl = ko.observable("");
    UnlockUrl = ko.observable(null);
    SaveAllowed = ko.observable(true);
    Key = ko.observable();
    //TypeSearcher: any;
    TypeSearcher = {
        ObjectId: this.Category().CategoryTypeId,
        ObjectValue: "Name",
        SearchType: "CategoryType",
        AutoComplete: true,
        AutoSearch: true,
        SearchItem: this.Categorytypes,
        //CustomFilter: { CategoryTypeId: this.CategoryTypeId() },
        Enabled: true
    };
    GetParentId() {
        let tmpTabPage: any = this.TabPage;
        let parentid = baoRouter.getRouteValue('parentId', tmpTabPage);
        return parentid;
    }
    CompleteCheck() {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.Category().CategoryName())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    ;
    Translate() {
        var translateDialog = new TranslateDialogViewModel(this.Category().CategoryName1, this.Category().CategoryName2, this.Category().CategoryName3, this.Category().CategoryName4, this.Category().CategoryName5);
        translateDialog.Open().then(() => {
        });
    }
    ;
    Save() {
        return super.Save()
            .done((serverResult) => {
            Bao.raiseEvent('allcategory:refresh', null);
        });
    }
    ;
    MinimizeEntity() {
        // get default result
        let minimizedEntity = super.MinimizeEntity();
        // add custom object this.Category()...
        minimizedEntity.Category = super.MinimizeEntity.call(this.Category());
        return minimizedEntity;
    }
    ;
    LoadFromServerAndMapToThis() {
        return Bao.post(this.RefreshUrl(), JSON.stringify({
            id: this.TabPage.ObjectId(),
            parentId: this.GetParentId()
        })).then((serverResult) => {
            this.TabPage.DirtyFlag.pause();
            let resultWithoutCategoryObject = {};
            for (let i in serverResult) {
                if (i !== "Category") {
                    resultWithoutCategoryObject[i] = serverResult[i];
                }
            }
            ko.map.fromJS(resultWithoutCategoryObject, this, this.TabPage.DirtyFlag);
            let category = this.Category();
            ko.map.fromJS(serverResult.Category, category, this.TabPage.DirtyFlag);
            if (this.IsNew() || (this.TabPage.ObjectId() != this.CategoryStructureId())) {
                this.TabPage.ObjectId(this.CategoryStructureId());
            }
            this.TabPage.DirtyFlag.reset();
        });
    }
    PerformRefresh() {
        this.TabPage.IsLoading(true);
        return this.LoadFromServerAndMapToThis().done(() => {
            this.TabPage.IsLoading(false);
            //baoRouter.replaceHash('masterdata/category/' + this.OpenData());
        });
    }
    ;
    init() {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        let tmpTabPage: any = this.TabPage;
        this.Category().CategoryName.subscribe(() => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Category().CategoryName1(this.Category().CategoryName());
                    break;
                case 2:
                    this.Category().CategoryName2(this.Category().CategoryName());
                    break;
                case 3:
                    this.Category().CategoryName3(this.Category().CategoryName());
                    break;
                case 4:
                    this.Category().CategoryName4(this.Category().CategoryName());
                    break;
                case 5:
                    this.Category().CategoryName5(this.Category().CategoryName());
                    break;
            }
        });
        this.LoadFromServerAndMapToThis().then((model) => {
            Bao.post("MasterData/Category/GetCategoryColors", (result) => {
                if (result != null) {
                    this.CategoryColors(result.CategoryColors);
                    def.resolve();
                }
            });
            this.TabPage.SessionTabId = this.SessionTabId();
        });
        return def.promise();
    }
    ;
    loaded() {
        this.ShiftbookCategoryTab = new TabPage(null);
        this.ShiftbookCategoryTab.Url("MasterData/ShiftbookCategoryTab");
        this.ShiftbookCategoryTab.IsClosable(false);
        this.ShiftbookCategoryTab.Visible(true);
        this.TabController.AddTab(this.ShiftbookCategoryTab);
        this.TabPage.IsLoading(false);
    }
    ;
    Unlock() {
        return $.Deferred<void>().resolve().promise();
    }
    Delete() {
        this.TabPage.IsLoading(true);
        return Bao.post(this.DeleteUrl(), JSON.stringify({ id: this.CategoryStructureId() }), () => {
            this.TabPage.IsLoading(false);
            this.TabPage.DirtyFlag(false);
            window.baorequire(["Services/AppTabController"], (AppTabController) => {
                Bao.raiseEvent('allcategory:refresh', null);
                AppTabController.RemoveTab(this.TabPage);
            });
        });
    }
}
export default CategoryViewModel;